







import { Component, Prop, Vue } from 'vue-property-decorator';
import { Story, statusType, privacyType } from '@/Story'
import * as utils from '@/utils';
import * as utils_auth from '@/utils_auth';
import { globalUC } from '@/UserCache'
import { StoryUser, howJoinedTypes, likelyToBeTypes, tutorialSteps, planTypes } from '@/StoryUser'
import { setIntervalAsync, SetIntervalAsyncTimer } from 'set-interval-async/fixed'    // a little better than calling regular setInterval when using async/await, because this offers safety from overlapping calls - https://github.com/ealmansi/set-interval-async
import { clearIntervalAsync } from 'set-interval-async'


import TutorialStepWelcomeComponent from '@/components/tutorial/TutorialStepWelcomeComponent.vue';             // @ is an alias to /src
const TutorialStepPhoneNumberComponent = () => import('@/components/tutorial/TutorialStepPhoneNumberComponent.vue')
const TutorialStepRecordForTutorialComponent = () => import('@/components/tutorial/TutorialStepRecordForTutorialComponent.vue')
const TutorialStepListenToOwnTutorialRecordingComponent = () => import('@/components/tutorial/TutorialStepListenToOwnTutorialRecordingComponent.vue')
const TutorialStepChooseInviteOrExplore = () => import('@/components/tutorial/TutorialStepChooseInviteOrExplore.vue')
const TutorialStepPoseQuestionComponent = () => import('@/components/tutorial/TutorialStepPoseQuestionComponent.vue')
const TutorialStepProfilePicComponent = () => import('@/components/tutorial/TutorialStepProfilePicComponent.vue')
const TutorialStepFinishingComponent = () => import('@/components/tutorial/TutorialStepFinishingComponent.vue')

/*  static import way 
import TutorialStepPhoneNumberComponent from '@/components/tutorial/TutorialStepPhoneNumberComponent.vue';
import TutorialStepRecordForTutorialComponent from '@/components/tutorial/TutorialStepRecordForTutorialComponent.vue';
import TutorialStepListenToOwnTutorialRecordingComponent from '@/components/tutorial/TutorialStepListenToOwnTutorialRecordingComponent.vue';
import TutorialStepChooseInviteOrExplore from '@/components/tutorial/TutorialStepChooseInviteOrExplore.vue';
import TutorialStepPoseQuestionComponent from '@/components/tutorial/TutorialStepPoseQuestionComponent.vue';
import TutorialStepProfilePicComponent from '@/components/tutorial/TutorialStepProfilePicComponent.vue';
import TutorialStepFinishingComponent from '@/components/tutorial/TutorialStepFinishingComponent.vue';
*/

// we use dynamic components to swap out which tutorial component is shown
//  * https://vuejs.org/v2/guide/components.html#Dynamic-Components
//  * https://stackoverflow.com/questions/43658481/passing-props-dynamically-to-dynamic-component-in-vuejs

// export type tutorialSteps = 'welcome'|'enterPhoneNumber'|'tutorialStoryCreated'|'recordForTutorial'|'listenToOwnTutorialRecording'|'uploadProfilePic'|'chooseInviteOrExplore'|'inviteListeners'|'inviteStoryTeller'|'poseQuestion'|'finishingScreen';
const tutorialComponents = {
  welcome: TutorialStepWelcomeComponent,
  enterPhoneNumber: TutorialStepPhoneNumberComponent,
  tutorialStoryCreated: null,
  recordForTutorial: TutorialStepRecordForTutorialComponent,
  listenToOwnTutorialRecording: TutorialStepListenToOwnTutorialRecordingComponent,
  uploadProfilePic: TutorialStepProfilePicComponent,
  chooseInviteOrExplore: TutorialStepChooseInviteOrExplore,
  poseQuestion: TutorialStepPoseQuestionComponent,
  finishingScreen: TutorialStepFinishingComponent
}

@Component({
  name: 'TutorialComponent',
  components: { 
    TutorialStepWelcomeComponent,
    TutorialStepPhoneNumberComponent,
    TutorialStepRecordForTutorialComponent,
    TutorialStepListenToOwnTutorialRecordingComponent,
    TutorialStepChooseInviteOrExplore,
    TutorialStepPoseQuestionComponent,
    TutorialStepProfilePicComponent,
    TutorialStepFinishingComponent
    }
})
export default class TutorialComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public modalShow: boolean = false
  public modalSize: string = "md"
  public modalTitle: string = null
  public stepShowing: tutorialSteps = null
  public activeTutorialComponent = null
  public inReadState: boolean = false

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading; }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get isAuthenticated(): StoryUser { return this.$store.getters.isAuthenticated }
  public get inTutorial(): boolean { return this.$store.state.inTutorial; }

  public async onStepSkipped(step: tutorialSteps) {
    if (this.$store.state.devmode) console.log(`${this.$options.name} onStepSkipped(${step})`)
    // this.modalShow = false
    await this.user.markTutorialStepSkipped(step)
    this.lastTutorialActivityTime = new Date()
    await this.readStateAndPathAndShowCorrectTutorial()
  }
  public async onStepDone(step: tutorialSteps) {
    if (this.$store.state.devmode) console.log(`${this.$options.name} onStepDone(${step})`)
    // this.modalShow = false
    await this.user.markTutorialStepDone(step)
    this.lastTutorialActivityTime = new Date()
    await this.readStateAndPathAndShowCorrectTutorial()

    if (step === 'finishingScreen') {
      this.modalShow = false
    }

    // for some steps that get done (e.g. tutorialStoryCreated and recordForTutorial), you should refresh the stories feed
    //  actually this can be jarring.  maybe just refresh at end of tutorial
    // if (step === tutorialSteps.tutorialStoryCreated || step === tutorialSteps.recordForTutorial || step === tutorialSteps.poseQuestion) {
    if (step === 'finishingScreen') {
      if (this.$store.state.devmode) console.log(`Refreshing because just did step ${step} and path is ${this.$route.path}`)
      this.$router.go(0);
    }

  }
  public exitTutorial(): void {
    if (this.timerRecurring) clearIntervalAsync(this.timerRecurring)
    this.timerRecurring = null
    this.modalShow = false
    this.$store.commit("setInTutorial", { inTutorial: false });     // this will get this component destroyed!
  }

  // private, non-reactive member variables
  private timerRecurring: SetIntervalAsyncTimer
  private lastTutorialActivityTime: Date = null

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    if (this.user) window.analytics.identify(this.user.getIdAsString(), this.user.getTraitObjectForSegment());

    this.lastTutorialActivityTime = new Date()
    await this.readStateAndPathAndShowCorrectTutorial()

    // start polling task that reads state of user to figure out what to tutorial step to show
    // we poll in case user is on multiple devices (like Juan was), and also that's how recordForTutorial auto proceeds
    this.timerRecurring = setIntervalAsync(async function() {
      await this.readStateAndPathAndShowCorrectTutorial()
    }.bind(this), 3000)

  }
  private async beforeDestroy() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

    if (this.timerRecurring) clearIntervalAsync(this.timerRecurring)
    this.timerRecurring = null
  }

  private showTutorialStep(step: tutorialSteps) {
    if (this.stepShowing === step) return
    if (this.$store.state.devmode) console.log(`Activating tutorial step ${step}`)
    this.modalSize = 'md'
    this.modalTitle = null
    this.activeTutorialComponent = tutorialComponents[step]
    this.stepShowing = step
    this.modalShow = true
  }
  private isDone(step: tutorialSteps) { return this.user.tutorialStepsDone.includes(step) }
  private isSkipped(step: tutorialSteps) { return this.user.tutorialStepsSkipped.includes(step) }
  private isDoneOrSkipped(step: tutorialSteps) { return this.isDone(step) || this.isSkipped(step) }

  private async readStateAndPathAndShowCorrectTutorial() {
    if (this.inReadState) return
    this.inReadState = true
    if (this.$store.state.devmode) console.log(`TutorialComponent.readStateAndPathAndShowCorrectTutorial()`)

    // read state
    if (!this.user) {
      this.exitTutorial()
      this.inReadState = false
      return
    }

    // check to see if user has been idle for over 10 minutes (safety check)
    const idleTimeInSec: number = (new Date().getTime() - this.lastTutorialActivityTime.getTime()) / 1000
    if (idleTimeInSec > 600) {
      this.inReadState = false
      return
    }

    // sync with DB in case user is proceeding on phone
    const updatedUser: StoryUser = await globalUC.get(this.userId, true)
    if (updatedUser) {
      console.assert(this.userId === updatedUser.getIdAsString())           // sanity check that we're still logged in as correct user
      updatedUser.updateMeToCacheStoreAndLocalStorage()
    }

    // welcome = 0, enterPN, tutorialStoryCreated, recordForTutorial, listenToOwnTutorialRecording, askMoreLikely, inviteListeners, inviteTeller, poseQuestion, profilePic, finishingScreen

    // check to see if user already finished tutorial
    if (this.isDoneOrSkipped('finishingScreen')) {
      this.exitTutorial()
      this.inReadState = false
      return
    }

    // check to see if user elected earlier to skip entire tutorial (actually UI doesn't even allow this)
    if (this.isSkipped('welcome')) {
      this.exitTutorial()
      this.inReadState = false
      return
    }

    // anyone who has gone through quiz has pretty much already done the welcome step
    if (!this.isDoneOrSkipped('welcome') && this.user.userDidQuiz()) {
      await this.onStepDone('welcome')
    }

    // welcome
    if (!this.isDoneOrSkipped('welcome')) {
      this.showTutorialStep('welcome')
      this.inReadState = false
      return
    }

    // enterPN - i considered skipping this step for likelyToBeTypes.listener, but decided, nah, we want everyone to do this
    if (!this.isDoneOrSkipped('enterPhoneNumber') && this.user.phoneNumberIds.length === 0 && !this.user.userDidQuizAsChampion()) {
      this.showTutorialStep('enterPhoneNumber')
      this.inReadState = false
      return
    }

    /*
    // special check to skip ahead if they've somehow already done a recording (can this actually happen?)
    if (this.user.numRecordings > 0) {
      if (!this.isDone(tutorialSteps.recordForTutorial)) await this.onStepSkipped(tutorialSteps.recordForTutorial)
      if (!this.isDone(tutorialSteps.listenToOwnTutorialRecording)) await this.onStepSkipped(tutorialSteps.listenToOwnTutorialRecording)
    }
    */

    // tutorialStoryCreated - this is a passive tutorial step
    if (!this.isDoneOrSkipped('tutorialStoryCreated') && !this.isDoneOrSkipped('recordForTutorial') && this.user.phoneNumberIds.length > 0) {
      // create the tutorial story for this user by making a POST call to server
      try {
        this.$store.commit('setLoading', { loading: true });
        const url: string = utils.getURLprefix() + '/api/stories'
        const response: any = await utils.makePostCall(url, { circleId: this.user.circleId, storyTellerId: this.userId, isTutorial: true } );
        this.$store.commit('setLoading', { loading: false });

        if (!response || !response.data) throw(new Error('TutorialComponent.onOK() got null response or null response.data'))

        if (response.data.error) {
          // hopefully never happens
          this.$store.commit('setLoading', { loading: false });
          utils.toast(this, 'Error', response.data.error)
          if (response.data.error === 'auth failure') {
            this.exitTutorial()
            await utils_auth.logout()
            this.inReadState = false
            return
          }
        }

        if (response.data.story) {
          // success
          await this.onStepDone('tutorialStoryCreated')        // mark done (this is a passive tutorial step)
        }

      } catch (error) {
        utils.toast(this, 'System Error', 'Could not start story')
        if (this.$store.state.devmode) console.error(error);
        this.inReadState = false
        return
      } finally {
        this.$store.commit('setLoading', { loading: false });
      }
    }

    // recordForTutorial
    if (!this.isDoneOrSkipped('recordForTutorial') && this.user.numRecordings === 0 && this.user.phoneNumberIds.length > 0) {
      this.showTutorialStep('recordForTutorial')
      this.inReadState = false
      return
    }

    // if you get here, we assume you did the recordForTutorial if you hadn't skipped it
    if (!this.isDoneOrSkipped('recordForTutorial') && this.user.numRecordings > 0) await this.onStepDone('recordForTutorial')

    // listenToOwnTutorialRecording
    if (!this.isDoneOrSkipped('listenToOwnTutorialRecording') && !this.isSkipped('recordForTutorial') && this.user.numRecordings > 0) {
      this.showTutorialStep('listenToOwnTutorialRecording')
      this.inReadState = false
      return
    }


    // profilePic
    if (!this.isDoneOrSkipped('uploadProfilePic') && !this.user.profilePic) {
      this.showTutorialStep('uploadProfilePic')
      this.inReadState = false
      return
    }

    // TODO: consider skipping choosePlan if
    //  * we already know their likelyToBe (from invite or ad)

    /*
    // choosePlan
    if (!this.isDoneOrSkipped('choosePlan')) {
      this.showTutorialStep(''choosePlan'')
      this.inReadState = false
      return
    }
    */

    // chooseInviteOrExplore
    if (!this.isDoneOrSkipped('chooseInviteOrExplore') && !this.user.userDidQuizAsChampion()) {
      this.showTutorialStep('chooseInviteOrExplore')
      this.inReadState = false
      return
    }

    // TODO: consider skipping inviteListeners, inviteTeller if
    //  * they already have friends

    /*
    // inviteListeners
    if (!this.isDoneOrSkipped(tutorialSteps.inviteListeners)) {
      this.showTutorialStep(tutorialSteps.inviteListeners)
      this.inReadState = false
      return
    }

    // inviteTeller and his circle
    if (!this.isDoneOrSkipped (tutorialSteps.inviteTeller)) {
      this.showTutorialStep(tutorialSteps.inviteTeller)
      this.inReadState = false
      return
    }
    */

    // poseQuestion
    if (!this.isDoneOrSkipped('poseQuestion') && await this.user.hasSomeoneToPoseTo()) {
      this.showTutorialStep('poseQuestion')
      this.inReadState = false
      return
   }

    // finishingScreen
    if (!this.isDoneOrSkipped('finishingScreen')) {
      this.showTutorialStep('finishingScreen')
      this.inReadState = false
      return
    }

    // exit the tutorial cuz nothing else to do
    this.exitTutorial()

  }



}
